/**
 * created by jiangtao
 */


import getId from 'utils/randomId.js'
import Vue from 'vue'
import { recordControlActions } from '$vuex/stores/page.js'
import copy from 'fast-copy'

/**
 * 数结构节点交换
 */
export const switchNode = (node1, node2, nodes, updateIds = false, state, recordActions) => {
  let p1 = node1.parent;
  let p2 = node2.parent;

  let sibings1 = p1 ? node1.parent.children : nodes;
  let sibings2 = p2 ? node2.parent.children : nodes;

  let index1 = sibings1.findIndex(node => node.id === node1.id);
  let index2 = sibings2.findIndex(node => node.id === node2.id);


  if (updateIds) {

    const tempId = node1.id
    node1.id = node2.id
    node1.controlId = node2.id

    node2.id = tempId
    node2.controlId = tempId
    if (node1._id) {
      let uniqId = node2._id
      node2._id = node1._id
      node1._id = uniqId
    }
  }
  if (p1) {
    node2.parent = p1;
    node2.parentId = p1.id
  } else {
    node2.parent = null
    node2.parentId = ''
  }

  sibings1.$set(index1, node2);
  if (p1) {
    node1.parent.childrenIds = node1.parent.children.map(c => c.id)
    recordActions(state, node1.parent, 'modify')
  }
  if (p2) {
    node1.parent = p2;
    node1.parentId = p2.id
  } else {
    node1.parent = null
    node1.parentId = ''
  }

  sibings2.$set(index2, node1);
  if (p2) {
    node2.parent.childrenIds = node2.parent.children.map(c => c.id)
    recordActions(state, node2.parent, 'modify')
  }

  recordActions(state, node1, 'modify')
  recordActions(state, node2, 'modify')
}

/**
 * @param {*} selectNode 选中的节点
 * @param {*} parentsNode 目标节点，可能为父辈节点
 */

export const isParents = (selectNode, parentsNode) => {
  let parent = selectNode.parent
  while (parent) {
    if (parent.id == parentsNode.id) return true
    parent = parent.parent
  }
  return false
}
/**
 * @description 将节点node2 添加到另一个节点node1 最后，（相当于appendChild移动）
 * node1: this.control
 * node2: chooseControl
 */
export const moveNodeAsLastNode = (node1, node2, nodes, state, recordActions) => {
  const hasParent = node2.parent
  const siblings = (node2.parent && node2.parent.id) ? node2.parent.children : nodes
  const sibings1 = node1.children
  const actions = []
  const index = siblings.findIndex(oneControl => oneControl.id == node2.id);

  // 删除相邻
  if (index > -1) {
    siblings.splice(index, 1)
    if (hasParent) {
      node2.parent.childrenIds = node2.parent.children.map(c => c.id)
      recordActions(state, node2.parent, 'modify')
    }
    // 完全删除
    actions.push({
      type: 'remove',
      index: index,
      node: node2,
      siblings,
      nodes
    })
    actions.removeNode = node2
  }
  // 以新的控件添加
  var newNode = node2
  // newNode.id = getId()
  // newNode.controlId = newNode.id
  newNode.parent = node1;
  newNode.parentId = node1.id
  sibings1.push(newNode);

  actions.push({
    type: 'add',
    index: sibings1.length - 1,
    siblings: sibings1,
    nodes,
    node: newNode
  })
  actions.addNode = newNode
  recordActions(state, newNode, 'modify')
  node1.childrenIds = node1.children.map(c => c.id)
  recordActions(state, node1, 'modify')
  return actions
}

export const removeSelectControl = (state, control) => {
  let index = state.selectedControls.indexOf(control)
  if (index > -1) {
    state.selectedControls.splice(index, 1)
    return true
  }
  return false
}


export const addSelectControl = (state, control) => {
  if (control) {
    control.active = true
    state.selectedControls.push(control)
    return true
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/node.js